import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useLoading } from "@shared/hooks/useLoading";
import { cleanupZohoSalesIQ } from "@shared/hooks/useZohoSalesIQ";
import { MainLayout } from "@shared/ui/MainLayout";

export const LogoutPage = () => {
  const navigate = useNavigate();
  const { thisLoading, notLoading, loading } = useLoading();

  useEffect(() => {
    thisLoading();
    localStorage.removeItem("user");
    localStorage.setItem("user", "");
    cleanupZohoSalesIQ(import.meta.env.VITE_ZOHO_SCRIPT_ID);
    notLoading();
    navigate("/");
  }, []);

  return <MainLayout loading={loading} />;
};
